import React from 'react';
import './Product.css';
import { useStateValue } from '../StateProvider/StateProvider';
import star from '../../assets/images/star.png';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

function Product({ id, title, image, price, rating, description, category }) {
  const [{ cart, totalCartItems }, dispatch] = useStateValue();
  const priceDollars = price.toString().split('.')[0];
  let priceCents = price.toString().split('.')[1];
  if (priceCents === undefined) priceCents = '00';
  if (priceCents.length < 2) priceCents += '0';

  let productImage = document.getElementById(`product-${id}`);

  const descriptionLength = 130;
  if (description.length > descriptionLength)
    description = description.substring(0, descriptionLength) + '...';

  const addToCart = () => {
    let dispatchObject;
    const checkForProduct = (currentProduct) => currentProduct.item.id === id;
    const alreadyInCart = cart.some(checkForProduct);
    if (alreadyInCart) {
      const cartIndex = cart.map((product) => product.item.id).indexOf(id);
      let newCart = cart;
      newCart[cartIndex].quantity++;
      dispatchObject = {
        type: 'ADD_TO_CART',
        cart: newCart,
        totalCartItems: totalCartItems + 1,
        selectedCartItems: newCart,
        totalSelectedCartItems: totalCartItems + 1,
      };
    } else {
      dispatchObject = {
        type: 'ADD_TO_CART',
        item: {
          id: id,
          title: title,
          image: image,
          price: price,
          rating: rating,
          description: description,
        },
        totalCartItems: totalCartItems + 1,
        totalSelectedCartItems: totalCartItems + 1,
      };
    }
    dispatch(dispatchObject);
  };

  return (
    <div className="product">
      <div className="product__info">
        <p className="product__title">{title}</p>
        {productImage != null &&
        productImage.naturalWidth > productImage.naturalHeight ? (
          <img
            id={`product-${id}`}
            src={image}
            alt={title}
            className="product__imageWide"
          />
        ) : (
          <img id={`product-${id}`} src={image} alt={title} />
        )}
        <p className="product__price">
          <span className="app__priceSymbol">$</span>
          <strong className="app__priceDollars">{priceDollars}</strong>
          <span className="app__priceCents">{priceCents}</span>
        </p>
        <div className="product__rating">
          {Array(rating)
            .fill()
            .map((_, index) => (
              <img
                key={index}
                className="product__ratingStar"
                src={star}
                alt=""
              />
            ))}
        </div>
        <div className="product__description">
          <p>{description}</p>
        </div>
      </div>
      <button className="app__button" onClick={addToCart}>
        <ShoppingCartIcon className="app__shoppingCartIcon" />
        <span>Add To Cart</span>
      </button>
    </div>
  );
}

export default Product;
